import React, { useState } from 'react';

const MOTTOS = [
  {
    state: 'Ohio',
    motto: 'With God, All Things Are Possible',
    year: 1959,
    language: 'English',
    verse: 'But Jesus beheld them, and said unto them, With men this is impossible; but with God all things are possible.',
    ref: 'Matthew 19:26',
    note: 'Ohio is the only state whose motto is a direct quotation from the Bible. It was proposed by a twelve-year-old boy named James Mastronardo and adopted by the state legislature in 1959. Its source in the Gospel of Matthew records the words of the Lord Jesus Christ Himself.',
    category: 'direct',
  },
  {
    state: 'Florida',
    motto: 'In God We Trust',
    year: 2006,
    language: 'English',
    verse: 'It is better to trust in the LORD than to put confidence in man.',
    ref: 'Psalm 118:8',
    note: 'Florida shares its motto with the United States of America. The national motto was adopted in 1956, and it first appeared on U.S. coins in 1864. Francis Scott Key wrote in 1814, "And this be our motto: In God is our trust." Florida officially designated it as the state motto in 2006.',
    category: 'direct',
  },
  {
    state: 'South Dakota',
    motto: 'Under God the People Rule',
    year: 1885,
    language: 'English',
    verse: 'Blessed is the nation whose God is the LORD; and the people whom he hath chosen for his own inheritance.',
    ref: 'Psalm 33:12',
    note: 'South Dakota\'s motto affirms that the authority of the people is under the authority of God. The Bible consistently teaches that all earthly rule is subject to the God who ordains it.',
    category: 'direct',
  },
  {
    state: 'Arizona',
    motto: 'Ditat Deus',
    year: 1863,
    language: 'Latin',
    translation: 'God Enriches',
    verse: 'The blessing of the LORD, it maketh rich, and he addeth no sorrow with it.',
    ref: 'Proverbs 10:22',
    note: 'Arizona\'s Latin motto declares plainly that God is the source of all true wealth and provision. The Bible teaches the same truth throughout the book of Proverbs and the Psalms.',
    category: 'direct',
  },
  {
    state: 'Colorado',
    motto: 'Nil Sine Numine',
    year: 1861,
    language: 'Latin',
    translation: 'Nothing Without the Deity',
    verse: 'For without me ye can do nothing.',
    ref: 'John 15:5',
    note: 'Colorado\'s founders acknowledged that nothing is accomplished apart from God. The Lord Jesus Christ spoke these same words to His disciples, declaring that apart from Him, no lasting work is possible.',
    category: 'direct',
  },
  {
    state: 'Kentucky',
    motto: 'Deo Gratiam Habeamus',
    year: 2002,
    language: 'Latin',
    translation: 'Let Us Be Grateful to God',
    verse: 'In every thing give thanks: for this is the will of God in Christ Jesus concerning you.',
    ref: '1 Thessalonians 5:18',
    note: 'Kentucky adopted this Latin motto in 2002 as a secondary motto alongside "United We Stand, Divided We Fall." It calls the people to gratitude toward God, reflecting the biblical command to give thanks in all things.',
    category: 'direct',
  },
  {
    state: 'Connecticut',
    motto: 'Qui Transtulit Sustinet',
    year: 1662,
    language: 'Latin',
    translation: 'He Who Transplanted Still Sustains',
    verse: 'Thou hast brought a vine out of Egypt: thou hast cast out the heathen, and planted it.',
    ref: 'Psalm 80:8',
    note: 'Connecticut\'s motto is rooted in Psalm 80, which describes God transplanting His people like a vine from Egypt into the Promised Land. The early settlers of Connecticut saw themselves as a people transplanted by God into a new land, sustained by His hand.',
    category: 'biblical',
  },
  {
    state: 'Rhode Island',
    motto: 'Hope',
    year: 1664,
    language: 'English',
    verse: 'Which hope we have as an anchor of the soul, both sure and stedfast, and which entereth into that within the veil.',
    ref: 'Hebrews 6:19',
    note: 'Rhode Island\'s one-word motto appears beneath an anchor on the state seal. The imagery directly parallels Hebrews 6:19, which describes the Christian\'s hope as an anchor for the soul. Roger Williams founded Rhode Island on the principle of religious liberty, grounded in the Word of God.',
    category: 'biblical',
  },
  {
    state: 'Hawaii',
    motto: 'Ua Mau ke Ea o ka Aina i ka Pono',
    year: 1843,
    language: 'Hawaiian',
    translation: 'The Life of the Land Is Perpetuated in Righteousness',
    verse: 'Righteousness exalteth a nation: but sin is a reproach to any people.',
    ref: 'Proverbs 14:34',
    note: 'King Kamehameha III spoke these words in 1843 after British forces withdrew from Hawaii. The principle that a land endures through righteousness is found throughout the Bible, particularly in the book of Proverbs.',
    category: 'biblical',
  },
  {
    state: 'New York',
    motto: 'Excelsior',
    year: 1778,
    language: 'Latin',
    translation: 'Ever Upward',
    verse: 'I press toward the mark for the prize of the high calling of God in Christ Jesus.',
    ref: 'Philippians 3:14',
    note: 'The concept of pressing ever upward toward a higher calling echoes the Apostle Paul\'s exhortation to believers. New York\'s founding generation understood that the highest aspiration of any people is to reach toward God.',
    category: 'echo',
  },
  {
    state: 'Virginia',
    motto: 'Sic Semper Tyrannis',
    year: 1776,
    language: 'Latin',
    translation: 'Thus Always to Tyrants',
    verse: 'Where the Spirit of the Lord is, there is liberty.',
    ref: '2 Corinthians 3:17',
    note: 'Virginia\'s defiance of tyranny reflects a biblical principle: true freedom comes from the Lord. The Bible teaches that God alone is the ultimate authority, and that earthly rulers who set themselves above God invite His judgment.',
    category: 'echo',
  },
  {
    state: 'New Hampshire',
    motto: 'Live Free or Die',
    year: 1945,
    language: 'English',
    verse: 'Stand fast therefore in the liberty wherewith Christ hath made us free, and be not entangled again with the yoke of bondage.',
    ref: 'Galatians 5:1',
    note: 'Written by Revolutionary War General John Stark, this motto captures the spirit of a people who valued liberty above life itself. The Bible declares that true liberty is found in Christ, and that believers are commanded to stand fast in it.',
    category: 'echo',
  },
  {
    state: 'Massachusetts',
    motto: 'Ense Petit Placidam Sub Libertate Quietem',
    year: 1775,
    language: 'Latin',
    translation: 'By the Sword We Seek Peace, Only Peace Under Liberty',
    verse: 'And he shall judge among the nations, and shall rebuke many people: and they shall beat their swords into plowshares, and their spears into pruninghooks.',
    ref: 'Isaiah 2:4',
    note: 'Massachusetts acknowledged that peace is not achieved through passivity, yet the ultimate peace the Bible describes comes when the Lord Himself judges the nations and establishes His kingdom.',
    category: 'echo',
  },
  {
    state: 'Pennsylvania',
    motto: 'Virtue, Liberty, and Independence',
    year: 1875,
    language: 'English',
    verse: 'And beside this, giving all diligence, add to your faith virtue; and to virtue knowledge.',
    ref: '2 Peter 1:5',
    note: 'Pennsylvania\'s Quaker and Christian founders understood that virtue is the foundation of a free society. The Apostle Peter taught that virtue is to be added to faith as a mark of genuine Christianity.',
    category: 'echo',
  },
  {
    state: 'Kansas',
    motto: 'Ad Astra per Aspera',
    year: 1861,
    language: 'Latin',
    translation: 'To the Stars Through Difficulties',
    verse: 'For our light affliction, which is but for a moment, worketh for us a far more exceeding and eternal weight of glory.',
    ref: '2 Corinthians 4:17',
    note: 'Kansas settlers endured hardship to build something lasting. The Bible teaches that trials and afflictions, when endured faithfully, produce an eternal reward that far surpasses any earthly suffering.',
    category: 'echo',
  },
  {
    state: 'Oklahoma',
    motto: 'Labor Omnia Vincit',
    year: 1907,
    language: 'Latin',
    translation: 'Labor Conquers All Things',
    verse: 'Whatsoever thy hand findeth to do, do it with thy might.',
    ref: 'Ecclesiastes 9:10',
    note: 'The Bible repeatedly upholds the dignity and value of diligent labor. The book of Proverbs and Ecclesiastes both teach that honest work, done with one\'s full effort, is honorable before God.',
    category: 'echo',
  },
  {
    state: 'Minnesota',
    motto: 'L\'Étoile du Nord',
    year: 1858,
    language: 'French',
    translation: 'The Star of the North',
    verse: 'I shall see him, but not now: I shall behold him, but not nigh: there shall come a Star out of Jacob, and a Sceptre shall rise out of Israel.',
    ref: 'Numbers 24:17',
    note: 'Throughout the Bible, a star is used as a symbol of guidance and hope. Balaam\'s prophecy in Numbers foretold the coming of Christ as a Star out of Jacob. The concept of a guiding star speaks to God\'s sovereign direction over His people.',
    category: 'echo',
  },
  {
    state: 'South Carolina',
    motto: 'Dum Spiro Spero',
    year: 1776,
    language: 'Latin',
    translation: 'While I Breathe, I Hope',
    verse: 'But I would not have you to be ignorant, brethren, concerning them which are asleep, that ye sorrow not, even as others which have no hope.',
    ref: '1 Thessalonians 4:13',
    note: 'Hope is a central theme of the Christian faith. The Bible teaches that the believer\'s hope is not a wish, but a confident expectation grounded in the promises of God. As long as there is breath, there is an opportunity to trust in Christ.',
    category: 'echo',
  },
];

const CATEGORIES = {
  all: 'All Mottos',
  direct: 'Directly Reference God',
  biblical: 'Biblical Origin',
  echo: 'Echo Biblical Principles',
};

export default function StateMottos() {
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? MOTTOS : MOTTOS.filter(m => m.category === filter);

  return (
    <>
      {/* HERO */}
      <section className="hero" style={{ background: 'linear-gradient(165deg, var(--navy) 0%, var(--deep-blue) 40%, var(--royal) 100%)', minHeight: 'auto', padding: '5rem 2rem 4rem' }}>
        <div className="inner" style={{ textAlign: 'center' }}>
          <div className="section-label center">The Heritage They Cannot Erase</div>
          <h1 className="section-title" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', marginBottom: '1rem' }}>
            State Mottos &<br />Their Biblical Connections
          </h1>
          <p style={{ fontSize: '1.05rem', lineHeight: 1.8, color: 'rgba(245,240,232,0.75)', maxWidth: 650, margin: '0 auto 2rem' }}>
            Long before the culture decided God was unwelcome in the public square, the people who built this nation inscribed His name into the very identity of their states. These are not relics of a forgotten era. They are the official mottos that still stand today.
          </p>
          <div style={{ maxWidth: 600, margin: '0 auto', padding: '1.25rem 2rem', borderLeft: '3px solid var(--gold)', background: 'rgba(197,165,90,0.06)', textAlign: 'left' }}>
            <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: '1.1rem', lineHeight: 1.7, color: 'rgba(245,240,232,0.92)', marginBottom: '.25rem' }}>
              "The wicked shall be turned into hell, and all the nations that forget God."
            </p>
            <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '.8rem', letterSpacing: 2, color: 'var(--gold)' }}>Psalm 9:17</p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* INTRO */}
      <section style={{ background: 'linear-gradient(180deg, var(--navy), var(--deep-blue))' }}>
        <div className="inner">
          <div className="about-content" style={{ maxWidth: 750 }}>
            <p>
              The founders, settlers, and legislators of the American states did not build their governments on secular philosophy. They acknowledged God openly, officially, and without apology. Their mottos prove it.
            </p>
            <p>
              At least six states directly reference God in their official mottos. Several others draw their language from the Bible itself. Still others echo biblical principles of liberty, virtue, hope, and righteousness that shaped the American character from its earliest days.
            </p>
            <p>
              This page connects each of those mottos with the Scripture it reflects. The Bible verses are from the King James Version, the Bible that was read in the homes, churches, courtrooms, and legislatures of these very states when these mottos were written.
            </p>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* FILTER */}
      <section style={{ background: 'var(--deep-blue)', paddingBottom: '2rem' }}>
        <div className="inner">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '.75rem', justifyContent: 'center', marginBottom: '1rem' }}>
            {Object.entries(CATEGORIES).map(([key, label]) => (
              <button
                key={key}
                className={`v-btn${filter === key ? ' active' : ''}`}
                onClick={() => setFilter(key)}
                style={{ fontSize: '.75rem', padding: '.5rem 1.25rem' }}
              >
                {label} {key !== 'all' && `(${MOTTOS.filter(m => key === 'all' || m.category === key).length})`}
              </button>
            ))}
          </div>
          <p style={{ textAlign: 'center', fontFamily: "'Oswald', sans-serif", fontSize: '.8rem', letterSpacing: 2, color: 'var(--gold)' }}>
            SHOWING {filtered.length} OF {MOTTOS.length} MOTTOS
          </p>
        </div>
      </section>

      {/* MOTTO CARDS */}
      <section style={{ background: 'var(--deep-blue)', paddingTop: 0 }}>
        <div className="inner">
          {filtered.map((m, i) => (
            <div key={m.state} className="motto-card" style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(197,165,90,0.12)',
              padding: '2.5rem',
              marginBottom: '2rem',
              position: 'relative',
              overflow: 'hidden',
            }}>
              {/* State name & motto */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
                <div>
                  <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '.75rem', letterSpacing: 3, textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '.25rem' }}>
                    {m.state} {m.year && `\u00B7 ${m.year}`}
                  </p>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.6rem', fontWeight: 700, color: 'var(--white)', lineHeight: 1.3, marginBottom: '.25rem' }}>
                    "{m.motto}"
                  </h3>
                  {m.translation && (
                    <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '.85rem', letterSpacing: 1, color: 'rgba(245,240,232,0.6)' }}>
                      {m.language}: "{m.translation}"
                    </p>
                  )}
                </div>
                <span style={{
                  fontFamily: "'Oswald', sans-serif",
                  fontSize: '.65rem',
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  padding: '.4rem .8rem',
                  background: m.category === 'direct' ? 'rgba(178,34,52,0.15)' : m.category === 'biblical' ? 'rgba(197,165,90,0.12)' : 'rgba(255,255,255,0.06)',
                  color: m.category === 'direct' ? 'var(--crimson)' : m.category === 'biblical' ? 'var(--gold)' : 'rgba(245,240,232,0.6)',
                  border: `1px solid ${m.category === 'direct' ? 'rgba(178,34,52,0.25)' : m.category === 'biblical' ? 'rgba(197,165,90,0.2)' : 'rgba(255,255,255,0.1)'}`,
                  whiteSpace: 'nowrap',
                }}>
                  {m.category === 'direct' ? 'References God' : m.category === 'biblical' ? 'Biblical Origin' : 'Echoes Scripture'}
                </span>
              </div>

              {/* Scripture */}
              <div style={{ borderLeft: '3px solid var(--gold)', padding: '.75rem 0 .75rem 1.5rem', margin: '1.5rem 0', background: 'rgba(197,165,90,0.04)' }}>
                <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: '1.05rem', lineHeight: 1.8, color: 'rgba(245,240,232,0.92)', marginBottom: '.25rem' }}>
                  "{m.verse}"
                </p>
                <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '.8rem', letterSpacing: 2, color: 'var(--gold)' }}>{m.ref}</p>
              </div>

              {/* Note */}
              <p style={{ fontSize: '.95rem', lineHeight: 1.9, color: 'rgba(245,240,232,0.75)' }}>
                {m.note}
              </p>
            </div>
          ))}
        </div>
      </section>

      <div className="divider" />

      {/* CLOSING */}
      <section style={{ background: 'linear-gradient(180deg, var(--deep-blue), var(--navy))', textAlign: 'center' }}>
        <div className="inner" style={{ maxWidth: 700 }}>
          <h2 className="section-title" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)' }}>
            The Record Speaks for Itself
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: 2, color: 'rgba(245,240,232,0.8)', marginBottom: '2rem' }}>
            These mottos were not written by accident. They were chosen deliberately by men and women who understood that no state, no republic, and no people can endure without the blessing of Almighty God. The question is not whether America was built on these principles. The question is whether America will return to them.
          </p>
          <div style={{ borderLeft: '3px solid var(--gold)', padding: '.75rem 0 .75rem 1.5rem', background: 'rgba(197,165,90,0.04)', textAlign: 'left', maxWidth: 600, margin: '0 auto 2rem' }}>
            <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: 'italic', fontSize: '1.1rem', lineHeight: 1.7, color: 'rgba(245,240,232,0.92)', marginBottom: '.25rem' }}>
              "If my people, which are called by my name, shall humble themselves, and pray, and seek my face, and turn from their wicked ways; then will I hear from heaven, and will forgive their sin, and will heal their land."
            </p>
            <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: '.8rem', letterSpacing: 2, color: 'var(--gold)' }}>2 Chronicles 7:14</p>
          </div>
        </div>
      </section>
    </>
  );
}
